/**
 * Pixelgipfel PDP interactions (M37, überarbeitet m64):
 * - Scroll-Snap-Galerie mit unbegrenzten Medien (Bild/Video/Iframe/3D)
 * - KOMPLETT EVENT-DELEGIERT: Listener hängen am document, nicht an
 *   Elementen — übersteht DOM-Austausch durch Apps/Preview-Bar/Morphing.
 * - Lightbox mit Zoom und Slide-Navigation
 * - Zugängliche Tabs pro [data-pg-tabs]-Instanz
 */
(function () {
  'use strict';

  /* ============= Helpers ============= */
  function galleryRoot(el) {
    return el ? el.closest('[data-pg-gallery]') : null;
  }
  function slidesOf(root) {
    return Array.from(root.querySelectorAll('[data-pg-slide]'));
  }
  function currentOf(root) {
    return parseInt(root.dataset.pgCurrent || '0', 10) || 0;
  }

  function scopedTabs(wrap) {
    return Array.from(wrap.querySelectorAll('[role="tab"][data-pg-tab]')).filter(function (tab) {
      return tab.closest('[data-pg-tabs]') === wrap;
    });
  }

  function scopedTabPanels(wrap) {
    return Array.from(wrap.querySelectorAll('[role="tabpanel"][data-pg-tab-panel]')).filter(function (panel) {
      return panel.closest('[data-pg-tabs]') === wrap;
    });
  }

  function tabControlsPanel(tab, panel) {
    var controls = tab.getAttribute('aria-controls');
    var key = tab.getAttribute('data-pg-tab');
    return (controls && panel.id === controls) || panel.getAttribute('data-pg-tab-panel') === key;
  }

  function activateTab(tab, moveFocus) {
    var wrap = tab && tab.closest('[data-pg-tabs]');
    if (!wrap) return;

    var tabs = scopedTabs(wrap);
    var panels = scopedTabPanels(wrap);
    if (tabs.indexOf(tab) === -1 || !panels.some(function (panel) { return tabControlsPanel(tab, panel); })) return;

    tabs.forEach(function (item) {
      var active = item === tab;
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.setAttribute('tabindex', active ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      var active = tabControlsPanel(tab, panel);
      panel.hidden = !active;
      if (active) panel.setAttribute('data-active', 'true');
      else panel.removeAttribute('data-active');
    });

    if (moveFocus) tab.focus();
  }

  function initTabs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wraps = [];
    if (scope.matches && scope.matches('[data-pg-tabs]')) wraps.push(scope);
    scope.querySelectorAll('[data-pg-tabs]').forEach(function (wrap) { wraps.push(wrap); });

    wraps.forEach(function (wrap) {
      var tabs = scopedTabs(wrap);
      var panels = scopedTabPanels(wrap);
      if (!tabs.length || !panels.length) return;

      var active = tabs.find(function (tab) {
        return tab.getAttribute('aria-selected') === 'true' && panels.some(function (panel) {
          return tabControlsPanel(tab, panel);
        });
      }) || tabs.find(function (tab) {
        return panels.some(function (panel) { return tabControlsPanel(tab, panel); });
      });

      if (active) activateTab(active, false);
    });
  }

  function updateNav(root, idx) {
    var slides = slidesOf(root);
    idx = Math.max(0, Math.min(slides.length - 1, idx));
    root.dataset.pgCurrent = String(idx);
    var currentEl = root.querySelector('[data-pg-gallery-current]');
    if (currentEl) currentEl.textContent = String(idx + 1);
    var prevBtn = root.querySelector('[data-pg-gallery-prev]');
    var nextBtn = root.querySelector('[data-pg-gallery-next]');
    if (prevBtn) prevBtn.disabled = idx === 0;
    if (nextBtn) nextBtn.disabled = idx === slides.length - 1;
    root.querySelectorAll('[data-pg-gallery-thumb]').forEach(function (t) {
      var ti = parseInt(t.getAttribute('data-pg-gallery-thumb'), 10);
      t.setAttribute('aria-current', ti === idx ? 'true' : 'false');
      if (ti === idx) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    });
    var next = slides[idx + 1];
    if (next) {
      var nextImg = next.querySelector('img');
      if (nextImg && !nextImg.complete) nextImg.loading = 'eager';
    }
  }

  function goTo(root, idx) {
    var main = root.querySelector('[data-pg-gallery-main]');
    var slides = slidesOf(root);
    idx = Math.max(0, Math.min(slides.length - 1, idx));
    var slide = slides[idx];
    if (!main || !slide) return;
    /* Chrome verwirft programmatische Scrolls in snap-mandatory-Containern
       mit scroll-behavior:smooth (resnap zum gemerkten Ziel). Deshalb:
       Snap + Smooth kurz aus, instant springen, dann reaktivieren. */
    main.style.scrollSnapType = 'none';
    main.style.scrollBehavior = 'auto';
    main.scrollLeft = slide.offsetLeft;
    setTimeout(function () {
      main.style.scrollSnapType = '';
      main.style.scrollBehavior = '';
    }, 80);
    updateNav(root, idx);
  }

  /* ============= Delegierte Klicks ============= */
  document.addEventListener('click', function (e) {
    var t = e.target;

    /* Galerie: Thumbs / Prev / Next / Fullscreen / Bild-Zoom */
    var thumb = t.closest && t.closest('[data-pg-gallery-thumb]');
    if (thumb) {
      var r1 = galleryRoot(thumb);
      if (r1) goTo(r1, parseInt(thumb.getAttribute('data-pg-gallery-thumb'), 10));
      return;
    }
    var prev = t.closest && t.closest('[data-pg-gallery-prev]');
    if (prev) {
      var r2 = galleryRoot(prev);
      if (r2) goTo(r2, currentOf(r2) - 1);
      return;
    }
    var next = t.closest && t.closest('[data-pg-gallery-next]');
    if (next) {
      var r3 = galleryRoot(next);
      if (r3) goTo(r3, currentOf(r3) + 1);
      return;
    }
    var fsBtn = t.closest && t.closest('[data-pg-gallery-lightbox]');
    if (fsBtn) {
      var r4 = galleryRoot(fsBtn);
      if (r4) openLightbox(currentOf(r4), slidesOf(r4));
      return;
    }
    var zoomImg = t.closest && t.closest('img[data-pg-zoom-src]');
    if (zoomImg) {
      var slide = zoomImg.closest('[data-pg-slide]');
      var r5 = galleryRoot(zoomImg);
      if (slide && r5) openLightbox(parseInt(slide.getAttribute('data-pg-slide'), 10) || 0, slidesOf(r5));
      return;
    }

    /* Lightbox: Close / Prev / Next / Backdrop / Zoom */
    if (t.closest && t.closest('[data-pg-lightbox-close]')) { closeLightbox(); return; }
    if (t.closest && t.closest('[data-pg-lightbox-prev]')) {
      lightboxState.index = Math.max(0, lightboxState.index - 1);
      renderLightboxSlide();
      return;
    }
    if (t.closest && t.closest('[data-pg-lightbox-next]')) {
      lightboxState.index = Math.min(lightboxState.slides.length - 1, lightboxState.index + 1);
      renderLightboxSlide();
      return;
    }
    var lb = document.querySelector('[data-pg-lightbox]');
    if (lb && lightboxState.open && (t === lb || (t.classList && t.classList.contains('pg-lightbox__stage')))) {
      closeLightbox();
      return;
    }

    /* Tabs: generisch und pro [data-pg-tabs]-Instanz gekapselt */
    var tab = t.closest && t.closest('[role="tab"][data-pg-tab]');
    if (tab) {
      activateTab(tab, false);
      return;
    }
  });

  /* ============= Swipe/Scroll → aktiven Slide nachführen ============= */
  var scrollTimers = new WeakMap();
  document.addEventListener('scroll', function (e) {
    var main = e.target;
    if (!main || !main.matches || !main.matches('[data-pg-gallery-main]')) return;
    var root = galleryRoot(main);
    if (!root) return;
    clearTimeout(scrollTimers.get(main));
    scrollTimers.set(main, setTimeout(function () {
      var idx = Math.round(main.scrollLeft / main.clientWidth);
      if (idx !== currentOf(root)) updateNav(root, idx);
    }, 100));
  }, true); /* capture: scroll bubbelt nicht */

  /* ============= Keyboard ============= */
  document.addEventListener('keydown', function (e) {
    if (lightboxState.open) {
      if (e.key === 'Escape') { closeLightbox(); }
      else if (e.key === 'ArrowLeft') {
        lightboxState.index = Math.max(0, lightboxState.index - 1);
        renderLightboxSlide();
      } else if (e.key === 'ArrowRight') {
        lightboxState.index = Math.min(lightboxState.slides.length - 1, lightboxState.index + 1);
        renderLightboxSlide();
      }
      return;
    }

    var tab = e.target.closest && e.target.closest('[role="tab"][data-pg-tab]');
    if (tab) {
      var wrap = tab.closest('[data-pg-tabs]');
      var tabs = wrap ? scopedTabs(wrap) : [];
      var index = tabs.indexOf(tab);
      var nextIndex = index;
      if (index === -1 || !tabs.length) return;

      if (e.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
      else if (e.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
      else if (e.key === 'Home') nextIndex = 0;
      else if (e.key === 'End') nextIndex = tabs.length - 1;
      else return;

      e.preventDefault();
      activateTab(tabs[nextIndex], true);
      return;
    }

    var root = galleryRoot(document.activeElement);
    if (!root) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(root, currentOf(root) - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(root, currentOf(root) + 1); }
    else if (e.key === 'Home') { e.preventDefault(); goTo(root, 0); }
    else if (e.key === 'End') { e.preventDefault(); goTo(root, slidesOf(root).length - 1); }
  });

  /* ============= Lightbox ============= */
  var lightboxState = { open: false, index: 0, slides: [], zoomed: false };

  function openLightbox(idx, slides) {
    var lb = document.querySelector('[data-pg-lightbox]');
    if (!lb) return;
    lightboxState.slides = slides;
    lightboxState.index = idx;
    lightboxState.open = true;
    lb.setAttribute('data-open', 'true');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderLightboxSlide();
  }

  function closeLightbox() {
    var lb = document.querySelector('[data-pg-lightbox]');
    if (!lb) return;
    lb.setAttribute('data-open', 'false');
    lb.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lightboxState.open = false;
    lightboxState.zoomed = false;
    var stage = lb.querySelector('[data-pg-lightbox-stage]');
    if (stage) stage.innerHTML = '';
  }

  function renderLightboxSlide() {
    var lb = document.querySelector('[data-pg-lightbox]');
    if (!lb) return;
    var stage = lb.querySelector('[data-pg-lightbox-stage]');
    var counter = lb.querySelector('[data-pg-lightbox-current]');
    var slide = lightboxState.slides[lightboxState.index];
    if (!stage || !slide) return;

    if (counter) counter.textContent = String(lightboxState.index + 1);

    var type = slide.getAttribute('data-media-type');
    stage.innerHTML = '';
    lightboxState.zoomed = false;

    var node;
    if (type === 'image') {
      var origImg = slide.querySelector('img');
      var src = origImg ? (origImg.getAttribute('data-pg-zoom-src') || origImg.src) : '';
      node = document.createElement('img');
      node.className = 'pg-lightbox__media';
      node.src = src;
      node.alt = origImg ? origImg.alt : '';
      node.addEventListener('click', toggleZoom);
    } else if (type === 'video') {
      var origVideo = slide.querySelector('video');
      node = document.createElement('video');
      node.className = 'pg-lightbox__media';
      node.controls = true;
      node.autoplay = true;
      node.playsInline = true;
      if (origVideo) Array.from(origVideo.querySelectorAll('source')).forEach(function (s) {
        var newSource = document.createElement('source');
        newSource.src = s.src;
        newSource.type = s.type;
        node.appendChild(newSource);
      });
    } else if (type === 'external_video') {
      var origIframe = slide.querySelector('iframe');
      node = document.createElement('iframe');
      node.className = 'pg-lightbox__media';
      node.src = origIframe ? origIframe.src : '';
      node.allow = 'autoplay; encrypted-media; fullscreen';
      node.style.width = '90vw';
      node.style.height = '50.625vw';
      node.style.maxHeight = '88vh';
    } else if (type === 'model') {
      var origModel = slide.querySelector('model-viewer');
      node = document.createElement('model-viewer');
      node.className = 'pg-lightbox__media';
      if (origModel) node.src = origModel.src;
      node.setAttribute('auto-rotate', '');
      node.setAttribute('camera-controls', '');
      node.setAttribute('ar', '');
      node.style.width = '90vw';
      node.style.height = '80vh';
    }
    if (node) stage.appendChild(node);
  }

  function toggleZoom(e) {
    var img = e.target;
    lightboxState.zoomed = !lightboxState.zoomed;
    img.setAttribute('data-zoomed', lightboxState.zoomed ? 'true' : 'false');
    if (lightboxState.zoomed) {
      var rect = img.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    } else {
      img.style.transformOrigin = 'center center';
    }
  }

  /* ============= Initialer Zustand (Galerie und Tabs) ============= */
  function initGalleries() {
    document.querySelectorAll('[data-pg-gallery]').forEach(function (root) {
      updateNav(root, currentOf(root));
    });
  }

  function initPdp(root) {
    initGalleries();
    initTabs(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPdp(document); });
  } else {
    initPdp(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initPdp(e.target); });
})();
